//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from "@/mixins/renderFormMixins";
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      tableloading: false,
      reqBase: {},
      formModel: {
        type: 3,
        fileinfo: null,
        // 项目编码
        desc: null,
        // 描述
        merchant_name: null,
        filename: null
      },
      spinShow: false,
      fileList: [],
      // 用于存储当前上传的文件
      formRules: {
        desc: [{
          required: true,
          message: "备注不能为空",
          trigger: "change"
        }],
        filename: [{
          required: true,
          message: "文件名不能为空",
          trigger: "change"
        }],
        merchant_name: [{
          required: true,
          message: "代理商名称不能为空",
          trigger: "change"
        }],
        fileinfo: [{
          required: true,
          type: 'object',
          message: "请上传文件",
          trigger: "change"
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {
      type: Boolean,
      default: false
    },
    $store: {},
    setData: {},
    merchant_name: {},
    parent_name: {}
  },
  components: {},
  methods: {
    beforeUpload: function beforeUpload(file) {
      this.$refs['upload'].clearFiles();
      this.formModel.fileinfo = file;
    },
    handleChange: function handleChange(file) {
      this.fileList = [file];
      this.formModel.fileinfo = file;
      this.$refs[refName].validateField('fileinfo');
    }
  },
  mounted: function mounted() {},
  created: function created() {}
};